import styles from "./icon-btn.module.css";
import React, {ButtonHTMLAttributes} from "react";
import {cn} from "@/lib/utils";

interface IconBtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    size?: "md" | "lg"
}

export const IconBtn = ({children, size, className, ...props}: IconBtnProps) => {
    return (
        <button
            className={cn('bg-gray rounded-[8px] text-noble-black-300 flex items-center justify-center w-[32px] h-[32px] cursor-pointer', styles.Button, {[styles.ButtonLg]: size === 'lg'}, className)}
            {...props}
        >
            {children}
        </button>
    )
}
